<template>
<div :class="`formulate-input-element formulate-input-element--${context.type}`" :data-type="context.type" >
	<vue-simple-suggest
		v-model="model"
		:list="context.options"
		:filter-by-query="true"
		:display-attribute="'name'"
		@input="onSelect"
	>
		<div slot="suggestion-item" slot-scope="{ suggestion }">
			<i v-if="context.slotProps.component.iconList" :class="context.slotProps.component.iconList" ></i>
			{{ suggestion[keyLabel] }}
		</div>
	</vue-simple-suggest>
</div>
</template>

<script>
export default {
	props: {
		context: {
			type: Object,
			required: true
		},
	},
	data () {
		return {

		}
	},
	computed: {
		model: {
			get: function() {
				return this.context.model || null
			},
			set: function(newValue) {
				this.context.model = newValue;
			}
		},
		keyValue(){
			return this.context.slotProps.component.keyValue || 'value'
		},
		keyLabel(){
			return this.context.slotProps.component.keyLabel || 'label'
		},
		mode(){
			return this.context.slotProps.component.mode || 'input'
		},
	},

	methods: {
		onSelect(selected){
			const selectedItem = this.context.options ? this.context.options.find(option => option[this.keyLabel] == selected) : null
			if(selectedItem){
				// emito el objeto seleccioado completo
				this.$emit('selected', selectedItem)
			}else{
				// emito solo el texto del input
				console.log(this.mode)
				this.$emit('selected', selected)
			}
		},
	}
}
</script>

<style scoped lang="scss">

.formulate-input-element /deep/ .suggestions{
	
	li{
		transition: background-color 0.2s ease-in-out;

		div{
			padding: 6px 4px;
			display: flex;
			align-items: center;
		}
		&.hover{
			background-color: #eee !important;
		}
	}
  
	.icon{
		font-size: 20px;
		color: #999;
		margin-right: 10px;
		margin-left: 5px;
	}
}
</style>